/* eslint-disable import/no-unresolved */
import { isEqual } from "lodash";
import { partners } from "src/config/constant";
import { PRODUCT_ID, Products } from "./ProposalDetails/interfaces";

/* eslint-disable import/prefer-default-export */
const extractLoanKeys = (loanDetails: any) => {
  const filteredLoanDetails = {
    ...loanDetails.loan,
    ...loanDetails.plan,
    ...loanDetails.premiumFunding,
    ...loanDetails.premiumDetails
  } as any;
  delete filteredLoanDetails.totalPayment;
  return filteredLoanDetails;
};
export const checkLoanKeysDirty = (prev: any, curr: any) => {
  console.log("diff keys", extractLoanKeys(prev), extractLoanKeys(curr));
  return isEqual(extractLoanKeys(prev), extractLoanKeys(curr));
};

export const GENERAL_DETAILS_MAPPING = {
  companyName: (partnerId: string) => ({
    ageas: "Ageas Federal Bank",
    ...(partnerId === "federal" ? { federal: "Federal Bank" } : { idbi: "IDBI Bank" })
  })
};

export const loanDetailsProductWise: Record<string, any> = {
  [PRODUCT_ID.GHS]: {
    term: "Months"
  },
  [PRODUCT_ID.GLS]: {
    term: "Years"
  },
  [PRODUCT_ID.GHS_FOR_JIO]: {
    term: "Months"
  },
  [PRODUCT_ID.GHS_IDBI]: {
    term: "Months"
  },
  [PRODUCT_ID.GCS]: {
    term: "Months"
  }
};

export const products: Products = {
  GLS: 9069,
  GHS: 9078,
  GHS_FOR_JIO: 9099,
  GHS_IDBI: 9101,
  GCS: 9086,
  GCS_SREI: 9109
};

export const getAssignmentFlag = (toShow: boolean) => {
  if (!toShow) return false;
  return true;
};

export const prePopulateST1Code = [partners.SREI];
